<template lang="pug">
div.d-flex.align-center
  v-select(
    item-value="query"
    item-text="name"
    v-model="model.filters.license_type"
    clearable
    solo
    dense
    flat
    menu-props="offset-y"
    :disabled="loading"
    :items="model.options.license_types.list"
    @change="setQuery"
    label="License type"
  ).filter.mr-3
  v-select(
    item-value="query"
    item-text="name"
    v-model="model.filters.tenant"
    clearable
    solo
    dense
    flat
    menu-props="offset-y"
    :disabled="loading"
    :items="model.options.tenants.list"
    @change="setQuery"
    label="Tenant"
  ).filter
</template>

<script>
import {ChapterFiltersModel} from "@/models/filters/ChapterFiltersModel";

export default {
  props: {
    loading: Boolean,
  },

  data: () => ({
    model: {},
  }),

  created() {
    this.initFilters()
  },

  methods: {
    initFilters() {
      this.model = new ChapterFiltersModel(this.$route.query);
    },

    async setQuery() {
      try {
        await this.$router.replace({query: { ...this.$route.query, page: 1, ...this.model.getApiData()}})
      } catch (e) {
        console.log(e)
      }
      this.$emit('filterChanged');
    },
  },
};
</script>

<style lang="scss" scoped>
.filter {
  width: 160px;
  max-width: 160px;
}

.v-input::v-deep {
  .v-input__slot {
    margin: 0;
  }
  .v-input__control {
    min-height: auto!important;
  }
  .v-text-field__details {
    display: none;
  }
}
</style>